import { EmptystateKeyColored } from "components/icons/generated";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import EmptyState from "ds/components/EmptyState";
import Tooltip from "ds/components/Tooltip";
import { SeatLimit } from "types/generated";
import { SEAT_LIMITS_TOOLTIP } from "views/Account/Settings/SeatLimitsNotification/constants";
import useSeatLimit from "views/Account/Settings/SeatLimitsNotification/useSeats";

type PersonalSettingsApiKeysEmptyProps =
  | {
      isUnavailable: true;
    }
  | {
      isUnavailable?: false;
      onCreate: () => void;
      seats?: SeatLimit;
    };

const PersonalSettingsApiKeysEmpty = (props: PersonalSettingsApiKeysEmptyProps) => {
  const seats = props.isUnavailable ? undefined : props.seats;
  const { isLimitReached } = useSeatLimit(seats);

  if (props.isUnavailable) {
    return (
      <Box align="center" justify="center" grow="1">
        <EmptyState
          title="Personal API keys aren’t available on this organization"
          icon={EmptystateKeyColored}
          caption="Once your organization moves to Identity Access Management, you’ll be able to create keys that use your own permissions."
        />
      </Box>
    );
  }

  const { onCreate } = props;

  return (
    <Box align="center" justify="center" grow="1">
      <EmptyState
        title="You don’t have any personal API keys yet"
        icon={EmptystateKeyColored}
        caption="Personal API keys let you use Spacelift from the CLI, Terraform and the API with your own permissions."
      >
        <Tooltip
          active={isLimitReached}
          on={(tooltipProps) => (
            <Button
              onPress={onCreate}
              variant="primary"
              disabled={isLimitReached}
              {...tooltipProps}
            >
              Create API key
            </Button>
          )}
        >
          {SEAT_LIMITS_TOOLTIP}
        </Tooltip>
      </EmptyState>
    </Box>
  );
};

export default PersonalSettingsApiKeysEmpty;
